// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"cc41134c","455":"971df0bd","977":"1f73cf2d"}[chunkId] + ".chunk.js";
};